module.exports = __webpack_public_path__ + "img/investor_fenbushi@2x.e7305a91.png";